import React, { PureComponent } from "react";

export default class FieldScreenshotUpload extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.input.onChange(e.target.files[0]);
  }

  render() {
    return <input type="file" onChange={this.handleChange} />;
  }
}
